import * as React from 'react'
import { StylesConfig, CSSObjectWithLabel } from 'react-select'
import Select from '../../shared/base_react_select'
import { COLOR_BY_TYPE } from '../../shared/tags/badge'

const { I18n } = window as any

type TagType = keyof typeof COLOR_BY_TYPE

interface TagOption {
  type: TagType
  selected?: boolean
  value?: string | number
  label?: string
}

interface ByTagsSelectorProps {
  items: TagOption[]
  selectTag: (selected: TagOption[]) => void
  value?: TagOption[]
}

const dot = (color = '#ccc'): CSSObjectWithLabel => ({
  alignItems: 'center',
  display: 'flex',
  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 4,
    marginLeft: 8,
    height: 10,
    width: 10,
  },
})

const Styles: StylesConfig<TagOption, true> = {
  option: (styles, { data }) => ({ ...styles, ...dot(COLOR_BY_TYPE[data.type]) }),
  multiValue: (styles, { data }) => ({ ...styles, ...dot(COLOR_BY_TYPE[data.type]) }),
}

const Placeholder = I18n.t('application.actions.filter_by_what', {
  what: I18n.t('activerecord.models.tag.other')
})

export default function ByTagsSelector({ items, selectTag, value }: ByTagsSelectorProps) {
  const selectedValue = value ?? items.filter(tag => tag.selected)

  return (
    <div>
      <Select
        isMulti
        styles={Styles}
        value={selectedValue}
        options={items}
        onChange={selectTag}
        placeholder={Placeholder}
      />
    </div>
  )
}
